import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../../../../../components/Builder/BuilderUI';
import { useAppSelector } from '../../../../../../redux/hooks';
import { significanceCriteriaSelector } from '../../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../../utils/types';
import {
  FieldContext,
  SignificanceModeKey,
  TagOption,
} from '../../../../../../utils/apollo/graphqlSchema';
import SignificanceBreakdownField from './SignificanceBreakdownField';
import SignificanceBreakdownControlGroup from './SignificanceBreakdownControlGroup';
import SignificanceBreakdownVariants from './SignificanceBreakdownVariants';
import {
  EntityDropzoneDataTypeEnum,
  ISignificanceDropzoneDataType,
} from '../../../../../../components/DndEntity/validation';
import { createTagOptionInput } from '../../../../../../components/Builder/EntitySelection/utils';
import FieldDroppableZone from '../../../../../../components/DndEntity/DndDroppableZone/FieldDroppableZone';

const Row = styled.div`
  display: grid;
  grid-template-columns: 70px 1fr;
  grid-column-gap: 8px;
`;

const Label = styled(BuilderUI.InputLabel)`
  align-self: start;
  margin-top: 7px;
  text-align: right;
`;

const DividerRow = styled(Row)`
  margin-top: 12px;
  margin-bottom: 12px;
`;

const ControlRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

const fieldsDropzoneId = `Significance-Field-Entity-Dropzone`;
const tags = [
  createTagOptionInput(TagOption.Field, {
    field: {
      events: [],
      func: null,
      context: FieldContext.Breakdown,
      arrayObjectContext: null,
    },
  }),
];

const SignificanceBreakdownCriteria = () => {
  const significanceCriteria = useAppSelector(significanceCriteriaSelector);
  assertCondition(
    significanceCriteria?.modeKey === SignificanceModeKey.Breakdown,
  );
  const { field } = significanceCriteria;

  return (
    <>
      <Row>
        <Label>Breakdown</Label>
        <FieldDroppableZone
          dropzoneId={fieldsDropzoneId}
          tags={tags}
          data={
            {
              id: fieldsDropzoneId,
              type: EntityDropzoneDataTypeEnum.Significance,
            } satisfies ISignificanceDropzoneDataType
          }
          shouldFitContent
          customMessage="+ Add Field to Breakdown"
        >
          <SignificanceBreakdownField breakdownField={field} />
        </FieldDroppableZone>
      </Row>
      {field && (
        <>
          <DividerRow>
            <div />
            <BuilderUI.HorizontalDivider />
          </DividerRow>
          <Row>
            <Label>Control</Label>
            <ControlRow>
              <SignificanceBreakdownControlGroup />
              <SignificanceBreakdownVariants />
            </ControlRow>
          </Row>
        </>
      )}
    </>
  );
};

export default SignificanceBreakdownCriteria;
